module.exports = "<md-toolbar class=\"toolbar\">\n  <div class=\"toolbar__inner\">\n    <ng-content></ng-content>\n  </div>\n</md-toolbar>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar.component.html
// module id = ../../../../../src/app/toolbar/toolbar.component.html
// module chunks = 4